import { getAuthHeaders } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

async function handle(response, fallback) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || fallback);
  }
  return response.json();
}

// Register a company for the trust-topology feature. ABN/ACN checksum-validated server-side.
export const registerCompany = async ({ name, abn, acn, seats }) => {
  const response = await fetch(`${API_URL}/companies/register`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ name, abn, acn, seats }),
  });
  return handle(response, 'Company registration failed');
};

// Companies you created.
export const getMyCompanies = async () => {
  const response = await fetch(`${API_URL}/companies/mine`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  return handle(response, 'Failed to load companies');
};

// Upload contacts as [{ email, recency }]. Raw email is used transiently only;
// the server stores a hash — never raw non-user PII.
export const uploadContacts = async (companyId, contacts) => {
  const response = await fetch(`${API_URL}/companies/${companyId}/contacts`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ contacts }),
  });
  return handle(response, 'Contact upload failed');
};

// Linked nodes (consenting users) + a count of still-pending claims.
export const getTopology = async (companyId) => {
  const response = await fetch(`${API_URL}/companies/${companyId}/topology`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  return handle(response, 'Failed to load topology');
};

// Company inbox: node_added / contact_moved notices.
export const getCompanyNotifications = async (companyId) => {
  const response = await fetch(`${API_URL}/companies/${companyId}/notifications`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  return handle(response, 'Failed to load notifications');
};
